var render = function render(){var _vm=this,_c=_vm._self._c;return _c('veui-layout',{staticClass:"basic-container",class:{
        'basic-container-no-bg': _vm.noBackground,
        'is-style-v2': _vm.useV2,
        [`is-style-v2-${_vm.activeTheme}`]: true,
        'old-basic-layout': true,
        'old-show-v2-tip': !_vm.useV2 && _vm.isStyleV2,
    }},[[(_vm.useV2)?_c('qingduo-header-v2'):_c('qingduo-header')],_c('veui-content',[_c('router-view')],1),(_vm.showFooter)?_c('veui-footer',[_c('div',{staticClass:"copyright"},[_vm._v(_vm._s(_vm.copyright))])]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }